<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Joueurs</label>
      </div>
      <input name="buteur_joueur"
             :value="(joueur && joueur.prenom && joueur.postnom && joueur.nom) ? (joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() + ' ' +
                     joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() + ' ' +
                     joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase()) : ''"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nombre de buts</span>
      </div>
      <input :value="buteur.nombre_buts"
             name="buteur_nombre_buts"
             disabled
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Match</label>
      </div>
      <select disabled
              class="custom-select"
              name="buteur_match">
        <option>
          {{
            (equipes && match) ?
                (
                    equipes.filter((equipe) => equipe.equipe_id === match.equipe_a_id)[0].nom.toUpperCase() + ' vs ' +
                    equipes.filter((equipe) => equipe.equipe_id === match.equipe_b_id)[0].nom.toUpperCase() + ' (' +
                    (new Date(match.date_rencontre).toLocaleDateString() + match.temps_rencontre) + ')'
                ) : ''
          }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Saison</span>
      </div>
      <input :value="(saison && saison.date_debut && saison.date_fin) ? (saison.annee_debut + ' - ' +
                               saison.annee_fin) : ''"
             name="buteur_saison"
             disabled
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Commentaires</span>
      </div>
      <textarea :value="buteur.commentaires"
                name="buteur_commentaires"
                disabled
                class="form-control">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="buteur.date_creation"
             name="buteur_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="buteur.temps_creation"
             name="buteur_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="buteur.date_modification"
             name="buteur_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="buteur.temps_modification"
             name="buteur_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    buteur: {
      type: Object
    }
  },
  data(){
    return{
      joueur: null,
      saison: null,
      equipes: null,
      matchs: null,
      equipe_a: null,
      equipe_b: null,
      match: null,
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosGetOneData',
    ]),
  },
  computed: {
    ...mapGetters([

    ])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
    //
    this.axiosGetAllData({
      table: 'matchs_joues'
    })
        .then((data) => {
          this.matchs = data.data
          this.match = this.matchs.filter((match) => match.match_id === this.buteur.match_id)[0]
        })
        .catch((data) => {
          this.matchs = data
        })
    //
    this.axiosGetOneData({
      table: "joueurs",
      table_id: this.buteur.joueur_id
    })
        .then( (data) => {
          this.joueur = data.data
        })
        .catch( () => {
          console.log(data)
        })
    this.axiosGetOneData({
      table: "saisons",
      table_id: this.buteur.saison_id
    })
        .then( (data) => {
          this.saison = data.data
        })
        .catch( () => {
          console.log(data)
        })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buteurs/components/Read.vue